import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const DEFAULTS = {
  logo: "/lira-logo.png",
  footer_logo: "",
  hero: {
    image: "/hero-chocolates.jpg",
    heading: "LIRA CHOCOLATES",
    heading_font: '"Cinzel", serif',
    heading_color: "#ffffff",
    subheading: "Everyday fall essentials.",
    subheading_font: '"Times New Roman", Times, serif',
    subheading_color: "#ffffff",
    button_text: "Shop Collection",
    button_color: "#1A1A1A",
    button_text_color: "#ffffff",
    button_link: "/collection/all",
  },
  nav: [
    { label: "Solid Modal", slug: "solid-modal" },
    { label: "Print Modal", slug: "print-modal" },
    { label: "Chiffon", slug: "chiffon" },
    { label: "Accessories", slug: "accessories" },
  ],
  lifestyle_banner:
    "https://images.unsplash.com/photo-1545266241-3516e2a6e016?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHw0fHx3b21hbiUyMHNpbGslMjBoaWphYnxlbnwwfHx8fDE3ODQwNjUwNTJ8MA&ixlib=rb-4.1.0&q=85&w=1600",
  categories: {
    "solid-modal": "https://images.unsplash.com/photo-1708151729245-fa18bd75727e?w=800",
    "print-modal": "https://images.unsplash.com/photo-1552874869-5c39ec9288dc?w=800",
    "chiffon": "https://images.unsplash.com/photo-1650462167170-4cba33f8a24a?w=800",
    "accessories": "https://images.unsplash.com/photo-1576053139778-7e32f2ae3cfd?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  community_images: [],
};

const SiteSettingsContext = createContext({ ...DEFAULTS, refresh: () => {} });

export const useSiteSettings = () => useContext(SiteSettingsContext);

export const SiteSettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(DEFAULTS);

  const refresh = useCallback(() => {
    return api
      .get("/site-settings")
      .then((r) => setSettings({ ...DEFAULTS, ...r.data, loaded: true }))
      .catch(() => setSettings((s) => ({ ...s, loaded: true })));
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <SiteSettingsContext.Provider value={{ ...settings, refresh }}>
      {children}
    </SiteSettingsContext.Provider>
  );
};
